module.exports = __webpack_public_path__ + "static/media/logo-alt.abd8481d.svg";